/**
 * Formats the given string as upper case.
 * */
export var toUpperCase = {
    id: "toUpperCase",
    definition: function (value) {
        return value ? value.toUpperCase() : value;
    }
};
